import { Box } from '@mui/material';
import { PageHeader } from './PageHeader.tsx';
import type { ActionDescriptor, PageDescriptor } from '@finance/contracts';
import type { PageWidth } from './AppContentContainer.tsx';

export type { PageWidth };

export interface PageProps {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
  actions?: ActionDescriptor[];
  actionNode?: React.ReactNode;
  onAction?: (action: ActionDescriptor) => void;
}

export function Page({ children, title, subtitle, actions, actionNode, onAction }: PageProps) {
  return (
    <Box component="article" sx={{ display: 'flex', flexDirection: 'column', minHeight: '100%' }}>
      {title && (
        <PageHeader
          title={title}
          subtitle={subtitle}
          actions={actions}
          actionNode={actionNode}
          onAction={onAction}
        />
      )}
      <Box sx={{ flex: 1 }}>{children}</Box>
    </Box>
  );
}

export function pageWidthForContract(contract?: PageDescriptor): PageWidth {
  return contract?.presentation?.width ?? 'standard';
}
